<template>
    <div class="woodchopper" :class="{ 'woodchopper--return': percent > 50 }">
    </div>
</template>

<script>
    export default {
        name: "WoodChopper",
        props: ["from", "to", "percent"],
        data() {
            return {
                timeline: undefined,
                map: undefined
            }
        },
        mounted() {
            this.map = document.querySelector(".map").getBoundingClientRect()
            this.timeline = gsap.timeline({defaults:{ease: "linear"} });
            this.timeline.pause()
        },
        watch: {
            from(val) {
                this.timeline
                    .set(this.$el, {
                        x: this.from.x - this.map.x,
                        y: this.from.y - this.map.y,
                    })
                    .to(this.$el, {
                        x: this.to.x - this.map.x,
                        y: this.to.y - this.map.y,
                    })
                    .to(this.$el, {
                        x: this.from.x - this.map.x,
                        y: this.from.y - this.map.y,
                    })
            },
            percent(val) {
                this.timeline.progress(val / 100)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .woodchopper {
        position: absolute;
        width: 36px;
        height: 41px;
        z-index: 0;
        animation: peon 1s steps(5) infinite;
        background: url('../assets/images/PeonBackSprite.png') top center no-repeat;

        &--return {
            background-image: url('../assets/images/WoodWorkerSprite.png');
        }
    }

    @keyframes peon {
        100% {
            background-position: 0 -205px;
        }
    }
</style>